import $ from 'gridstrap/lib/gs-zepto';

export class GSWizard {

	//
	// Properties
	//

	root;
	activeStep;
	allSteps;

	get counters() { return $(`.gs-Counter[data-gs-counter-name="${this.counterName}"]`); }
	get counterName() { return this.root.data('gsWizardCounterName'); }
	get counterBaseline() { return this.root.data('gsWizardCounterBaseline'); }
	get counterFloor() { return this.root.data('gsWizardCounterFloor'); }

	set height(value)      { this.root.css('height', value); }
	set isAnimating(value) { this.root.toggleClass('is-animating', !!value); }

	//
	// Methods
	//

	prev(evt) {
		this.move(evt, this.activeStep.prevStep);
		evt.stopPropagation();
	}

	next(evt) {
		let isValid = this.activeStep.validate();
		if (!isValid) return this.activeStep.track('invalid');

		this.move(evt, this.activeStep.nextStep);
		evt.stopPropagation();
	}

	skip(evt) {
		let isValid = this.activeStep.validate();
		this.activeStep.track(isValid ? 'skip' : 'invalid');
		if (!isValid) return;

		this.move(evt, this.activeStep.nextStep);
		evt.stopPropagation();
	}

	jump(evtOrId) {
		const isEvent = !!evtOrId.currentTarget;
		if (isEvent) evtOrId.stopPropagation();

		const id = isEvent ? $(evtOrId.currentTarget).data('gsFormOptionTarget') : evtOrId;
		const target = this.root.find(`[data-gs-wizard-step-id="${id}"]`).gs(0);
		this.move(evtOrId, target);
	}

	move(evt, target) {
		const clicked = $(evt.currentTarget);
		const activeStep = this.activeStep.root;
		const fields = activeStep.find('.gs-FormField');

		let delay = 0;
		if (fields.length > 0) delay = 500;
		if (clicked.is('[role~="delayed"]')) delay = 500;

		this.isAnimating = true;
		this.setCounter(target);
		setTimeout(() => target.select(), delay);
	}

	setCounter(target) {
		let targetIndex = target.index;
		let beforeTarget = this.allSteps.filter(step => step.index < targetIndex);
		let count = this.counterBaseline;

		for (let step of beforeTarget) {
			let checked = step.root.find('[data-gs-form-option-counter-modifier]:checked');
			if (checked.length === 0) continue;

			let modifierStr = checked.data('gsFormOptionCounterModifier');
			let isPercentage = modifierStr.endsWith('%');
			let modifier = isPercentage ? parseInt(modifierStr) / 100 : parseInt(modifierStr);
			count = isPercentage ? count * modifier : count + modifier;
		}

		while (count < this.counterFloor) count += 10;
		this.counters.gs('value', Math.round(count));
	}

	//
	// Initializers & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.root.on('click', '[role~="prev"]', evt => this.prev(evt));
		this.root.on('click', '[role~="next"]', evt => this.next(evt));
		this.root.on('click', '[role~="skip"]', evt => this.skip(evt));
		this.root.on('click', '[role~="jump"]', evt => this.jump(evt));
	}

	gsOnInit() {
		this.allSteps = this.root.find('.gs-Wizard-step').gs();
		this.activeStep = this.root.find('.gs-Wizard-step').first().gs(0);
		this.activeStep.activate();
		setTimeout(() => this.activeStep.autofocus(), 200);
	}
}
